import { compareObjects, extractOptionIds } from "@/utils/global"

export const generateConfigurations = (product) => {
 if(product?.option_details){ 
  const opDetails = Object.entries(product?.option_details)
  const optionsObject = opDetails.reduce((acc, curr) => 
  Object.defineProperty(acc, curr[0], 
    {value: curr[1][0], 
    writable    : true,  
    enumerable  : true,
    configurable: true }), {})
    return optionsObject
  }else{
    return null
  }
}

export function formatOptions(obj) {
  const formattedObj = {};
  for (const key in obj) {
    const { is_swatch, option_id, attribute_id } = obj[key];
    if (!is_swatch) {
      formattedObj[key] = { option_id:attribute_id, option_value: option_id };
    } else {
      formattedObj[key] = { option_id:attribute_id, option_value: option_id };
    }
  }
  return formattedObj;
}

export const findProductWithConfigurations = (product, configurations) => {  
  if(product?.option_details){ 
  const configuationsArr = Object.values(configurations)?.map(config => config?.option_id)
  const compareArrays = (a, b) =>
  a.length === b.length &&
  a.every((element, index) => element === b[index]);

  const configuredProduct = product["_configurables"].
  find(pr => compareArrays(Object.values(pr?.options), configuationsArr))
  
  return configuredProduct 
  }else{
    return null
  }
}

export const getProductVariant = (product)=>{
  const isConfigurable = product?.type_id === "configurable";
  const productVariant = !isConfigurable ? product : product?._configurables?.find(variant => compareObjects(variant?.options, extractOptionIds(product?.selectedConfigurations)) )
  return productVariant
}